import React, { Component } from 'react';

class Title extends Component {
  render(){
    const { colorHeading, titleText, level  = '' } = this.props;
    const headingColor = colorHeading ? "hidden" : "visible";

    return(
      <div>
        {titleText !== ''
          ? <h5 className="summary" style={{color: headingColor}}>{titleText}</h5>
          : null
        }

        {this.props.heading ?
          level === "1"
            ? <h1 className="slogan">{this.props.heading}</h1>
            : <h2 className="slogan remove-margin-top">{this.props.heading}</h2>
          : null
        }
      </div>
    );
  }
}

export default Title;



// WEBPACK FOOTER //
// ./src/layout/Title.js